const Accordions = {
    accordions: null,
    init: () => {
        Accordions.accordions = document.querySelectorAll(".open-accordion");
        [...Accordions.accordions].forEach(accordion => {
            accordion.addEventListener("click", Accordions.openAccordion, true);
        });
    },
    openAccordion: (e) => {
        let elem = e.target ? e.target : e.toElement;
        let id = elem.getAttribute("data-content");


        let target = document.getElementById(id);
        if (!target.classList.contains("active")) {
            target.style.height = target.scrollHeight + "px";
            target.classList.add("active");

            elem.classList.add("active");
            elem.textContent = elem.getAttribute("data-less")

        } else {
            target.style.height = 0;
            target.classList.remove("active");

            elem.classList.remove("active");
            elem.textContent = elem.getAttribute("data-more")
        }
    }
}

export default Accordions;